import checkout from "./form2";

const {
  formField2: {
    taxAlternatePayerName,
    taxAlternatePayerId
  },
} = checkout;

const initialValues2 = {
  [taxAlternatePayerName.name]: "",
  [taxAlternatePayerId.name]: "",
};

export default initialValues2;
